<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t("lang.trucks_and_trailers") }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('tanker_trucks.create')" @invoke-method="invokeMethod($event)" action="openTankerTruckForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetTankerTrucks(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="tanker_trucks" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openTankerTruckForm(props.item)">
                                <td>{{ props.item.truck_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.truck_name }}</td>
                                <td>{{ props.item.payload }}</td>
                                <td class="text-center">{{ props.item.num_of_compartments }}</td>
                                <td>{{ props.item.driver_id ? props.item.driver_name : "---" }}</td>
                                <td>{{ props.item.serial }}</td>
                                <td>{{ props.item.vehicle_type }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="tanker_trucks"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="tanker_truck_dialog">
                <v-card>
                    <v-form ref="form_tanker_truck">
                        <v-card-title>
                            <span class="headline">{{ tanker_truck.truck_id ? $t("lang.edit_truck_or_trailer") : $t("lang.add_truck_or_trailer") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeTankerTruckDialog"
                                :dialog-status="tanker_truck_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="tanker_truck.company_id"
                                            :label="$t('lang.company')"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('tanker_trucks.company_id')"
                                            @change="getDrivers(tanker_truck.company_id)"
                                            :disabled="tanker_truck.truck_id ? true : false"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="tanker_truck.vehicle_type"
                                            :label="$t('lang.vehicle_type')"
                                            :items="[
                                                { text: 'Truck', value: 'truck' },
                                                { text: 'Trailer', value: 'trailer' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('tanker_trucks.vehicle_type')"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 v-if="$isSet(tanker_truck.vehicle_type)">
                                        <v-text-field
                                            v-model="tanker_truck.truck_name"
                                            :label="tanker_truck.vehicle_type == 'truck' ? `${$t('lang.truck_name')} *` : `${$t('lang.trailer_name')} *`"
                                            :counter="showCounter(tanker_truck.truck_name, 'tanker_trucks.truck_name')"
                                            :rules="ifValid('tanker_trucks.truck_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs6>
                                        <v-text-field
                                            v-model="tanker_truck.gvwr"
                                            :label="`${$t('lang.gvwr')} *`"
                                            :counter="showCounter(tanker_truck.gvwr, 'tanker_trucks.gvwr')"
                                            :rules="ifValid('tanker_trucks.gvwr')"
                                        ></v-text-field>
                                    </v-flex> -->

                                    <v-flex xs12>
                                        <bc-select
                                            v-model="tanker_truck.num_of_compartments"
                                            :label="`${$t('lang.num_of_compartments')} *`"
                                            :items="[
                                                { text: 'None - Tractor Only', value: '0' },
                                                { text: '1', value: '1' },
                                                { text: '2', value: '2' },
                                                { text: '3', value: '3' },
                                                { text: '4', value: '4' },
                                                { text: '5', value: '5' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('tanker_trucks.num_of_compartments')"
                                            @change="setCompartmentFields(tanker_truck.num_of_compartments)"
                                        ></bc-select>
                                    </v-flex>
                                    <v-layout v-if="tanker_truck.num_of_compartments != 0" row wrap grid-list-xl>
                                        <v-flex xs2 v-if="tanker_truck.num_of_compartments >= 1">
                                            <v-text-field
                                                v-model="tanker_truck.compartment1"
                                                :label="`${$t('lang.compartment1')} *`"
                                                :counter="showCounter(tanker_truck.compartment1, 'tanker_trucks.compartment1')"
                                                :rules="ifValid('tanker_trucks.compartment1')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2 v-if="tanker_truck.num_of_compartments >= 2">
                                            <v-text-field
                                                v-model="tanker_truck.compartment2"
                                                :label="`${$t('lang.compartment2')} *`"
                                                :counter="showCounter(tanker_truck.compartment2, 'tanker_trucks.compartment2')"
                                                :rules="ifValid('tanker_trucks.compartment2')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2 v-if="tanker_truck.num_of_compartments >= 3">
                                            <v-text-field
                                                v-model="tanker_truck.compartment3"
                                                :label="`${$t('lang.compartment3')} *`"
                                                :counter="showCounter(tanker_truck.compartment3, 'tanker_trucks.compartment3')"
                                                :rules="ifValid('tanker_trucks.compartment3')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2 v-if="tanker_truck.num_of_compartments >= 4">
                                            <v-text-field
                                                v-model="tanker_truck.compartment4"
                                                :label="`${$t('lang.compartment4')} *`"
                                                :counter="showCounter(tanker_truck.compartment4, 'tanker_trucks.compartment4')"
                                                :rules="ifValid('tanker_trucks.compartment4')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2 v-if="tanker_truck.num_of_compartments >= 5">
                                            <v-text-field
                                                v-model="tanker_truck.compartment5"
                                                :label="`${$t('lang.compartment5')} *`"
                                                :counter="showCounter(tanker_truck.compartment5, 'tanker_trucks.compartment5')"
                                                :rules="ifValid('tanker_trucks.compartment5')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-flex xs12 v-if="tanker_truck.num_of_compartments != 0">
                                        <v-text-field
                                            v-model="tanker_truck.payload"
                                            :label="`${$t('lang.payload_weight')} *`"
                                            :counter="showCounter(tanker_truck.payload, 'tanker_trucks.payload')"
                                            :rules="ifValid('tanker_trucks.payload')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="tanker_truck.vehicle_type == 'truck'">
                                        <bc-autocomplete
                                            v-model="tanker_truck.driver_id"
                                            :label="$t('lang.driver_id')"
                                            :items="drivers"
                                            item-value="people_id"
                                            item-text="combined_name"
                                            :rules="ifValid('tanker_trucks.driver_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tanker_truck.serial"
                                            :label="$t('lang.serial')"
                                            :counter="showCounter(tanker_truck.serial, 'tanker_trucks.serial')"
                                            :rules="ifValid('tanker_trucks.serial')"
                                        ></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs6>
                                        <v-text-field
                                            v-model="tanker_truck.meter_style"
                                            :label="`${$t('lang.meter_style')} *`"
                                            :counter="showCounter(tanker_truck.meter_style, 'tanker_trucks.meter_style')"
                                            :rules="ifValid('tanker_trucks.meter_style')"
                                        ></v-text-field>
                                    </v-flex> -->
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="tanker_truck.truck_id" color="error" @mouseup.left="$refs.delete_tanker_trucks.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeTankerTruckDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveTankerTrucks">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_tanker_trucks"
                :heading="$t('lang.delete_tanker_truck')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteTankerTrucks(tanker_truck.truck_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openTankerTruckForm" },
                { title: this.$t("lang.refresh"), action: "dbGetTankerTrucks", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.truck_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.company"), sortable: false, width: "7%" },
                { text: this.$t("lang.truck_name"), sortable: false, width: "7%" },
                { text: this.$t("lang.payload"), sortable: false, width: "7%" },
                { text: this.$t("lang.num_of_compartments"), sortable: false, width: "7%", align: "center" },
                { text: this.$t("lang.driver_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.serial"), sortable: false, width: "7%" },
                { text: this.$t("lang.vehicle_type"), sortable: false, width: "7%" },
            ],
            enableAddModal: true,
            enableEditModal: true,
            customers: null,
            tanker_truck: {},
            filter: {
                search: "",
                status: "1",
                company_id: "",
            },
            tanker_truck_dialog: false,
            drivers: [],
            dbGetTankerTrucks: _.debounce(this.getTankerTrucks, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchTankerTrucks", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tanker_trucks) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchTankerTrucks({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.tanker_trucks) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.tanker_trucks.tanker_trucks_filter,
            page: (state) => state.tanker_trucks.page,
            rules_tanker_trucks: (state) => state.tanker_trucks.rules_tanker_trucks,
            tanker_truck_status_options: (state) => state.settings.tanker_truck_status_options,
            tanker_trucks: (state) => state.tanker_trucks.tanker_trucks,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchTankerTrucks", "saveTankerTruck", "deleteTankerTruck", "fetchCustomers", "fetchPeople"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openTankerTruckForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_tanker_truck) item ? this.$refs.form_tanker_truck.resetValidation() : this.$refs.form_tanker_truck.reset();

                    this.$nextTick(() => {
                        if (item.company_id) this.getDrivers(item.company_id);
                        this.tanker_truck = item != null ? this.assignObj2(item, this.rules_tanker_trucks) : {};

                        this.tanker_truck_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "tanker_truck", params: { id: item.truck_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_tanker_truck) item ? this.$refs.form_tanker_truck.resetValidation() : this.$refs.form_tanker_truck.reset();
                    this.tanker_truck = item != null ? this.assignObj2(item, this.rules_tanker_trucks) : {};
                    this.tanker_truck_dialog = true;
                    console.log(this.tanker_truck);
                } else {
                    this.$router.push({ name: "tanker_truck" });
                }
            }
        },
        saveTankerTrucks() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_tanker_truck")) {
                    let body = this.prepForm(this.tanker_truck, this.rules_tanker_trucks);
                    if (body.driver_id == "") body.driver_id = null;

                    if (body.vehicle_type == "trailer" && body.driver_id != "") body.driver_id = null;

                    this.saveTankerTruck({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getTankerTrucks();
                                this.closeTankerTruckDialog();
                            } else {
                                this.$router.push({ name: "tanker_truck", params: { id: data.truck_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteTankerTrucks(id = null) {
            this.deleteTankerTruck({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getTankerTrucks();
                    this.closeTankerTruckDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeTankerTruckDialog() {
            this.tanker_truck_dialog = false;
            this.$refs.delete_tanker_trucks.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getTankerTrucks(pg_refresh = false) {
            this.startLoader();

            this.fetchTankerTrucks({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.tanker_truck_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getDrivers(company_id) {
            this.tanker_truck.driver_id = "";
            this.fetchPeople({ body: { options: 1, company_id: company_id } }).then((data) => {
                if (typeof data !== "undefined" && data.people) {
                    this.drivers = data.people;
                }
            });
        },
        setCompartmentFields(num_of_compartments) {
            if (num_of_compartments < 5) {
                this.tanker_truck.compartment5 = "";
            }
            if (num_of_compartments < 4) {
                this.tanker_truck.compartment4 = "";
            }
            if (num_of_compartments < 3) {
                this.tanker_truck.compartment3 = "";
            }
            if (num_of_compartments < 2) {
                this.tanker_truck.compartment2 = "";
            }
        },
        async refresh(force = false) {
            if (this.tanker_trucks.length == 0 || force == true) {
                let parsedQuery = JSON.parse(JSON.stringify(to.query));
                this.fetchTankerTrucks({
                    body: parsedQuery,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.tanker_trucks) {
                        this.setQuery(parsedQuery, this.filter, this.default_filter);
                        this.finishLoader();
                    } else {
                        this.$router.push({ name: "dashboard", replace: true });
                    }
                });
            }
            if (this.customer_options.length == 0 || force == true) await this.fetchCustomers({ body: { options: 1 } });
        },
    },
};
</script>
